import { render, staticRenderFns } from "./contenter.vue?vue&type=template&id=166c0495&"
import script from "./contenter.vue?vue&type=script&lang=js&"
export * from "./contenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports